<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOMONTOALIADO.LBL_MONTOSALIADOS' | translate}}">

    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioMontoAliado" name="nomFormularioMontoAliado"
          *ngIf="!verDetalle">
      <div class="grid form-group">
        <div class="col-6 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTODESTINO.LBL_DESTINO' | translate }}</label>
            <label class="falso-combo-texto" *ngIf="edit">{{edMontoAliado.destinoProducto}}</label>
            <p-multiSelect id="idDestionos" name="nomDestinos" [options]="lisDestinos" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idDestinos" *ngIf="!edit"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idDestinos.invalid">
              {{ 'PRODUCTODESTINO.LBL_DESTINO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-6 md:col-6 lg:col-6">
          <div class="div-form">
            <label>{{ 'PRODUCTODESTINO.LBL_SUBDESTINOS' | translate }}</label>
            <p-multiSelect id="idSubdestino" name="nomDestinos" [options]="lisSubdestino" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idSubdestino"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTOALIADO.LBL_PERFIL' | translate }}</label>
            <label class="falso-combo-texto" *ngIf="edit">{{edMontoAliado.nombreRiesgo}}</label>
            <p-dropdown disableTab  id="idRiesgo" name="nomRiesgo" [options]="lisPerfiles" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idPerfilRiesgo" *ngIf="!edit"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPerfilRiesgo.invalid">
              {{ 'PRODUCTOMONTOALIADO.LBL_PERFIL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTOALIADO.LBL_CICLO' | translate }}</label>
            <label class="falso-combo-texto" *ngIf="edit">{{edMontoAliado.ciclo}}</label>
            <p-dropdown disableTab  id="idCiclo" name="nomCiclo" [options]="lisCiclos" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idListaPerfilesCiclos" *ngIf="!edit"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idListaPerfilesCiclos.invalid">
              {{ 'PRODUCTOMONTOALIADO.LBL_CICLO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTOALIADO.LBL_MONTOMAXIMO' | translate }}</label>
            <input type="text" pInputText id="idMontoMaximo"
                   name="nomMontoMaximo"
                   autocomplete="off"
                   formControlName="montoMaximo"
                   [maxlength]="18"
                   currencyMask
                   [options]="{ prefix: '$ ', thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0 }"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
              {{ 'PRODUCTOMONTOALIADO.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTOALIADO.LBL_PLAZOMAXIMO' | translate }} ({{ 'LBL_MESES' | translate }})</label>
            <input type="text" pInputText id="idPlazoMaximo"
                   name="nomPlazoMaximo"
                   autocomplete="off"
                   formControlName="plazoMaximo"
                   [maxlength]="3"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximo.invalid">
              {{ 'PRODUCTOMONTOALIADO.LBL_PLAZOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorAnalizamos" name="indicadorAnalizamos"
                        label="* {{ 'PRODUCTOMONTO.LBL_INDICADORANALIZAMOS' | translate}}"
                        (onChange)="validarIndicadores()"
                        formControlName="indicadorAnalizamos"></p-checkbox>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && errorIndicadores" style="display: block; padding: 0px;">
              {{ 'PRODUCTOMONTO.MSG_SELECCIONEINDICADOR' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorFlujoDigital" name="indicadorFlujoDigital"
                        label="* {{ 'PRODUCTOMONTO.LBL_INDICADORFLUJODIGITAL' | translate}}"
                        (onChange)="validarIndicadores()"
                        formControlName="indicadorFlujoDigital"></p-checkbox>
          </div>
        </div>
      </div>


      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <p-checkbox binary="true" id="indicadorGarantiaIdonea" name="indicadorGarantiaIdonea"
                        label="{{ 'PRODUCTOMONTO.LBL_GARANTIAIDONEA' | translate}}"
                        (onChange)="cambioGarantia($event)"
                        formControlName="indicadorGarantiaIdonea"></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorGarantiaIdonea.value">
          <div class="div-form">
            <label>* {{ 'PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIAMESES' | translate }}</label>
            <input type="text" pInputText id="idPlazoMaximoGarantiaIdonea"
                   name="nomPlazoMaximoGarantiaIdonea"
                   autocomplete="off"
                   formControlName="plazoMaximoGarantiaIdonea"
                   [maxlength]="3"
                   [minimo]="1"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximoGarantiaIdonea.invalid">
              {{ 'PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{ edit ? ('BTN_EDITAR' | translate) :  ('BTN_AGREGAR' | translate)}}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dtpromontoaliado.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando" #dtpromontoaliado
                 [value]="lisProductoMontoAliado" selectionMode="single" dataKey="idProductoMontoAliado"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.destinoProducto}}</td>
              <td>{{row.subDestino}}<span *ngIf="row.verCompleto" (click)="detalleTabla(row)" style="cursor: pointer;">...</span></td>
              <td>{{row.nombreRiesgo}}</td>
              <td>{{row.ciclo}}</td>
              <td>{{row.montoMaximo | dinero}}</td>
              <td>{{row.plazoMaximo}}</td>
              <td>{{row.plazoMaximoGarantiaIdonea}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorAnalizamos" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorFlujoDigital" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center" *ngIf="!verDetalle">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-certificate" data-toggle="tooltip"
                          title="{{'PRODUCTOMONTO.BTN_ACTIVIDADES' | translate}}" pButton *ngIf="row.subDestino && row.subDestino.trim()"
                          (click)="verActividades(row)"></button>
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editar(row)"></button>

                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)" *ngIf="!edit"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false" #dialo
           *ngIf="mosActividades"
          [(visible)]="mosActividades"
          [contentStyle]="{'width':'800px'}"
          header="{{ 'PRODUCTOMONTO.BTN_ACTIVIDADES'  | translate}}"
          [modal]="true">
  <app-loading *ngIf="carActividades"></app-loading>
  <ng-container *ngIf="!carActividades">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <div class="div-form">
          <label>{{ 'PRODUCTODESTINO.LBL_DESTINO' | translate }}</label>
          <label class="falso-combo-texto">{{regSeleccionado?.destinoProducto}}</label>
        </div>
      </div>
    </div>
    <form [formGroup]="formActividades" novalidate id="idFormActividades" name="nomFormularioActividades" *ngIf="!verDetalle">
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTODESTINO.LBL_SUBDESTINOS' | translate }}</label>
            <p-dropdown disableTab  id="idSubAct" name="nomDestAci" [options]="lisSubDestinoActividad"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        filter="filter" (onChange)="cargarActividades($event.value)"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idSubdestino"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="subActividades && fAct.idSubdestino.invalid">
              {{ 'PRODUCTODESTINO.LBL_SUBDESTINOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="fAct.idSubdestino.value">
          <div class="div-form">
            <label>* {{ 'PRODUCTODESTINO.LBL_ACTIVIDAD' | translate }}</label>
            <p-multiSelect id="idActividadRelacionada" name="actividad" [options]="listActividades" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idActividadRelacionada"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="subActividades && fAct.idActividadRelacionada.invalid">
              {{ 'PRODUCTODESTINO.LBL_ACTIVIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="button" (click)="guardarActividades()"
                  pButton></button>
        </div>
      </div>
    </form>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dtActividadesSub.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="colActividades" #dtActividadesSub
                 [value]="lisActividadesMostrar"
                 [paginator]="true" [rows]="4"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.subDestinoProducto}}</td>
              <td>{{row.actividadRelacionada}}</td>
              <td class="text-center" *ngIf="!verDetalle">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitarActividad(row)" *ngIf="!verDetalle"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
                pButton (click)="cerrarModal()"></button>
      </div>
    </div>
  </ng-container>
</p-dialog>

<p-confirmDialog #cd key="montos-aliados">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
